<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('global.menu.backoffice.edit-premium-features', { shop: formData?.name }) }}
            </h3>
        </template>

        <template #default>

            <v-row class="shop-info-container" justify="center">
                <v-col cols="9">
                    <v-label>Shop-Status von {{ formData.name }}</v-label>
                    <v-select v-model="formData.status" :items="status" variant="outlined" density="compact"
                        :hide-details="true" placeholder="No status"> </v-select>
                </v-col>
                <v-col cols="12">
                    <h2 class="text-h6">Choose Premium Features</h2>
                    <v-divider class="mt-0 pt-0"></v-divider>
                    <v-row>
                        <template v-for="feature in features" :key="feature">
                            <v-col cols="6" density="compact" class="py-0">
                                <v-checkbox density="compact" v-model="formData.premiumFeatures" :label="feature.name" hide-details="true" :value="feature" >
                                </v-checkbox>
                            </v-col>
                        </template>
                    </v-row>
                </v-col>
            </v-row>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="save">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "ShopPlanDialog",
    data() {
        return {
        }
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';


const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ translations: {} }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const props = defineProps({
    save: Function, // Define prop as a function
    items: Array
});

const status = computed(() => props.items.status)
const features = computed(() => props.items.features)





const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = {
        translations: { DE: { value: '' }, EN: { value: '' } },
    };
};
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}

.highlighted-country {
    font-weight: 800;
}
</style>
